import { type MetaFunction } from '@remix-run/node'

export const meta: MetaFunction = () => [
	{ title: 'Insuring against an Earthquake' },
	{
		name: 'description',
		content: 'Insuring your home against an earthquake.',
	},
]

export default function Component() {
	return (
		<>
			<h1 className="py-3 text-4xl font-black">
				Insuring your home against an earthquake
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				You can't accurately predict an earthquake. In states like California,
				carrying earthquake insurance is very common because earthquakes happen
				frequently. In NY, there are not a lot of earthquakes. Consequently,
				most New Yorkers don't purchase the coverage. Since earthquakes here{' '}
				<em>are</em> rare, the cost of the insurance is very minimal. Earthquake
				insurance does not come on a standard homeowner's policy, but you may be
				able to add it on or purchase a separate policy that will cover your
				home if a disaster were to occur. Please call or email today to find out
				what it would cost to add earthquake coverage to your homeowner's
				policy.
			</p>
		</>
	)
}
